import Modal from 'react-modal';

const setGlobalModalConfig = () => {
    Modal.setAppElement('#root');
    Modal.defaultProps.shouldCloseOnOverlayClick = false;
};


export default setGlobalModalConfig;